import { Injectable } from '@angular/core';
import { MenuService } from '@app/services/menu/menu.service';
import { MenuItemGroup } from '@app/interfaces';

const DocumentsMenu: MenuItemGroup = [
    {
        key: 'account.menu.myDocs',
        link: ['/profile', 'documents'],
        routerLinkExact: true,
    },
    {
        key: 'account.menu.publicDocs',
        link: ['/profile', 'documents', 'public'],
        routerLinkExact: true,
    },
];

@Injectable()
export class DocumentsMenuService extends MenuService {
    setBaseMenu(): void {
        this.baseMenu = DocumentsMenu;
    }
}
